import { Injectable } from '@angular/core';
import { CredentialsService, DecodedAuthUser } from '@app/auth/credentials.service';

/**
 * Fuente única de rol/permisos para la UI, leída del access token
 * (el backend serializa el AuthUser completo en el JWT).
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private credentialsService: CredentialsService) {}

  private get decodedToken(): DecodedAuthUser | null {
    return this.credentialsService.getDecodedToken();
  }

  get role(): string | null {
    return this.decodedToken?.role ?? null;
  }

  get userId(): number | null {
    return this.decodedToken?.id ?? null;
  }

  hasPermission(permission: string): boolean {
    return this.decodedToken?.permissions?.includes(permission) ?? false;
  }

  hasAny(permissions: string[]): boolean {
    const granted = this.decodedToken?.permissions;
    if (!granted?.length) {
      return false;
    }
    return permissions.some((permission) => granted.includes(permission));
  }
}
